export default "__VITE_ASSET__2cc3eb28__"